export const LocalStorageKeys = {
  gameTokenKey: "game_token",
} as const;
